import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

export interface IGetShotGunTemplate {
  id: number;
  title?: string;
  extended?: boolean;
}

export interface IShotgunTemplateGroup {
  group_index: number;
  start_hole: string;
  start_time: string;
  checked?: boolean;
  position?: number;
  id?: number;
}

export interface IApplyShotgunTemplate {
  tee_sheet_id: number;
  start_time: string;
  duration: number;
  lead_time: number;
  shotgun_template_id: number;
  division_id?: number;
  turn_division_id?: number;
  tournament_id?: number;
  league_id?: number;
  booking_category_ids?: Array<number>;
  open_lead_as_nine_holes?: boolean;
  full_round_lead_time?: number;
  nine_hole_lead_time?: number;
}

export interface IEditApplyShotgun {
  tee_sheet_id: number;
  shotgun_application_id: number;
  start_time: string;
  duration: number;
  lead_time: number;
  tournament_id?: number;
  league_id?: number;
}

export interface IPutShotgunTemplate {
  template_id: number;
  title: string;
  groups: Array<IShotgunTemplateGroup>;
  delete_group_ids: Array<number>;
}

// Get Tee Sheet Shotgun Template
export async function GetShotGunTemplate(params: IGetShotGunTemplate, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun"), params, useGlobalLoader, cancelToken);
}

// POST Tee Sheet Shotgun Template
export async function PostShotGunTemplate(
  params: { title: string; groups: Array<IShotgunTemplateGroup> },
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun"), params, useGlobalLoader);
}

export async function PutShotGunTemplate(params: IPutShotgunTemplate, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun"), params, useGlobalLoader);
}

export interface IPutShotgunTemplateGenerate {
  holes: number;
  direction?: "regular" | "reverse";
  course_id?: number;
}

// PUT Generate Shotgun Template
export async function PutShotGunTemplateGenerate(params: IPutShotgunTemplateGenerate, useGlobalLoader: boolean) {
  return await APIPut<IShotgunTemplateGroup[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/generate"),
    params,
    useGlobalLoader,
  );
}

// Put Tee Sheet Shotgun Template
export async function PutShotGunTemplateApply(params: IApplyShotgunTemplate, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/apply"), params, useGlobalLoader);
}

export async function PutEditShotgunApply(params: IEditApplyShotgun, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/apply/edit"), params, useGlobalLoader);
}

export async function GetEditShotgunPreview(params: Omit<IEditApplyShotgun, "league_id" | "tournament_id">, useGlobalLoader: boolean) {
  return await APIGet<{key: string; message: string}>(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/apply/edit/preview"), params, useGlobalLoader);
}

// DELETE Shotgun Template
export async function RemoveShotgunTemplate(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/remove"), params, useGlobalLoader);
}

// POST Tee Time
export async function PostShotgunTeeTime(params: any, useGlobalLoader: boolean) {
  return await APIPost(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/group/add"),
    params,
    useGlobalLoader,
  );
}

// PUT Remove Tee Time
export async function PutRemoveShotgunTeeTime(params: { tee_time_id: number }, useGlobalLoader: boolean) {
  return await APIPut(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/template/shotgun/group/remove"),
    params,
    useGlobalLoader,
  );
}
